export default __webpack_public_path__ + "static/media/brand-4.96ccd35b.jpg";